var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.323,
    height: 8.466,
    viewBox: "0 0 8.323 8.466",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "black-arrow",
    transform: "translate(-613.644 -556.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M616.466,557.531h4.894v4.759",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1.215
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_986",
    "data-name": "Line 986",
    y1: 7.019,
    x2: 6.517,
    transform: "translate(614.089 557.958)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1.215
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrow);
export default __webpack_public_path__ + "static/media/black-arrow.714973d24e97ee9bb7c8b218d3d9f8eb.svg";
export { ForwardRef as ReactComponent };